import WithRender from "../../templates/base/information.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getInformation"]),
    name: () => {
      return "Information";
    }
  }
});
